import React, { useEffect, useRef, useState } from "react";
import SaveIcon from "@mui/icons-material/Save";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import ArrowCircleDownIcon from "@mui/icons-material/ArrowCircleDown";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import axios from "axios";
import WebViewer from "@pdftron/webviewer";
import "./Sign.css";
import ReasonPopup from "../ReasonPopup/ReasonPopup";
import { useSelector,useDispatch } from "react-redux";
import {setDoc} from "../../app/slice/pdfslice"
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { formInfo, formstatus,getFormDeliveryOption,notificationWithCustomUrl,saveToBlob, sendMessageOnSave } from "../../apis/fileinfo";
import config from '../../env.json'

var hasfield:any = false;
var state:string = "start";
var bufferFromIframe:any = null;
var te:any = null;
var blobsign:any = null;
var reason:any='';
var deliveryModeLocal:any=[]
var recepientNameLocal="";
var formInfoLocal:any=null

function Sign() {
  const viewer:any = useRef(null);
  let fileName: any;
  const serializer = new XMLSerializer();
//   const [fileUrl, setFileUrl] = useState(
//     "https://testblobmedia.blob.core.windows.net/media/mirformfilled.pdf"
//   );
  
  const srfUrl = localStorage.getItem("formBlobStorageUrl")
  const [instance, setInstance] = useState<any>(null);
  const fileInfoState=useSelector((state:any)=>state.login)
  const {doc}=useSelector((state:any)=>state.login)
  const formRequestId=useSelector((state:any)=>state.login.id)
  const recepientName=useSelector((state:any)=>state.login.recepientName)
  const formIdActual=useSelector((state:any)=>state.login.formId)
  const [fileUrl, setFileUrl] = useState(srfUrl+formRequestId+".pdf");
  const [signFile, setSignFile] = useState(null);
  const [showPopup, setShowPopup] = useState(false);
  const [reasondata, setReasondata] = useState("");
  const [formId,setFormId]=useState(0);
  const [deliveryMode,setDeliveryModes]=useState<any>([]);
  const [recepientNameState,setRecepientNameState]=useState('');
  const [formInfoState,setFormInfoState]=useState<any>(null)
  const dispatch=useDispatch()
  const navigate=useNavigate()


  
  useEffect(()=>{
    if(formIdActual){
      formInfo(formIdActual,(res:any)=>{
        setFormInfoState(res);
        formInfoLocal=state;
        if(res.formDeliveries.length>0){
          setDeliveryModes(res.formDeliveries)
          deliveryModeLocal=res.formDeliveries;
        }
      
      })
    }
  },[formIdActual])

  const convertToXfdf = (changedAnnotation: any, action: any) => {
    let xfdfString = `<?xml version="1.0" encoding="UTF-8" ?><xfdf xmlns="http://ns.adobe.com/xfdf/" xml:space="preserve"><fields />`;
    if (action === "add") {
      xfdfString += `<add>${changedAnnotation}</add><modify /><delete />`;
    } else if (action === "modify") {
      xfdfString += `<add /><modify>${changedAnnotation}</modify><delete />`;
    } else if (action === "delete") {
      xfdfString += `<add /><modify /><delete>${changedAnnotation}</delete>`;
    }
    xfdfString += `</xfdf>`;
    return xfdfString;
  };

  // helper function to send annotation changes to WebSocket server
  const sendAnnotationChange = (annotation: any, action: any) => {
    console.log("adasdas");
    if (annotation.nodeType !== annotation.TEXT_NODE) {
      const annotationString = serializer.serializeToString(annotation);

      const annotations = convertToXfdf(annotationString, action);
      blobsign=new Blob([annotation]);
      console.log("annotation Data from UI ::" + annotationString + "\t");

      
    } else {
      console.log("No data for annotations");
    }
  };

  useEffect(() => {
    console.log('hi------>')
    if(formRequestId){
    setFormId(formRequestId)
    if(recepientName)
    {
      recepientNameLocal=recepientName;
      setRecepientNameState(recepientName);
    }
   
    if (instance) {
      if(doc)
      instance.loadDocument(doc);
      else
      instance.loadDocument(fileUrl);
    } else {
      WebViewer(
        {
          path: "/webviewerNew/lib",
          initialDoc: fileUrl,
          config:'/webviewerNew/scripts/localScript.js',
          fullAPI: true,
          disabledElements: [
            "toolbarGroup-Shapes",
            "toolbarGroup-Edit",
            "toolbarGroup-Insert",
            "toolbarGroup-Annotate",
            "toolbarGroup-Forms",
            "notesPanel",
            "viewControlsButton",
            "selectToolButton",
            "toggleNotesButton",
            "searchButton",
            "freeTextToolGroupButton",
            "crossStampToolButton",
            "checkStampToolButton",
            "dotStampToolButton",
            "rubberStampToolGroupButton",
            "dateFreeTextToolButton",
            "eraserToolButton",
            "panToolButton",
            // "signatureToolGroupButton",
            // "viewControlsOverlay",
            "textSignaturePanelButton",
            "imageSignaturePanelButton"
          ],
          licenseKey:
            "Optiks Solutions, Inc (p360.com):OEM:ZING Engagement Suite, BirdzAI::B+:AMS(20230818):BAA5A63D0447780AF360B13AC982527860615FC53EBB427B7C62159434401EFE14E4BEF5C7",
        
        },
        viewer.current
      ).then(async (instance:any) => {
        setInstance(instance);


        const {
          documentViewer,
          annotationManager,
          Annotations,
          PDFNet,
          Tools,
          Math
        } = instance.Core;
        const { WidgetFlags } = Annotations;
        const signatureTool = documentViewer.getTool('AnnotationCreateSignature');
        let signatureAnnotaionCustom1:any=null
        let signatureAnnotaionCordinate:any=null
        await PDFNet.initialize();
        
           fetch('https://testblobmedia.blob.core.windows.net/media/adobe_aatl_eutl.fdf').then(function(certExchange) {
          certExchange.blob().then(function(blobCertExchange) {
          instance.UI.VerificationOptions.loadTrustList(blobCertExchange);
          instance.UI.VerificationOptions.addTrustedCertificates([
            'https://testblobmedia.blob.core.windows.net/media/entrust_class_3_intermediate.cer',
          ]);
          console.log('loaded certificates');
        });
      });
      if(recepientNameState.length>0)
      annotationManager.setCurrentUser(recepientNameState)
      if(recepientNameLocal.length>0)
      annotationManager.setCurrentUser(recepientNameLocal)
      let ip:any="";
      let location:any="";
        hasfield=false
        let ipAddress:any=""
        try {
          ipAddress= await axios.get('https://api.db-ip.com/v2/free/self');
        } catch (error) {
          console.log(error)
        }
      
      if(ipAddress.data){
        ip=ipAddress.data.ipAddress
        location=ipAddress.data.city+" "+ipAddress.data.stateProv+","+ipAddress.data.countryCode
      }
        async function main() {
          

          const doc = await PDFNet.PDFDoc.createFromURL(fileUrl);
          if (doc) {
            try {
              const formData:any = {
                formstatus: "opened",
                SignedURL: fileUrl,
                formRequestId: formRequestId,
              };
              
              formstatus(formData)
              let tempdel:any=deliveryMode
          if(deliveryModeLocal.length>0)
          tempdel=  deliveryModeLocal        

          tempdel.findIndex((x:any)=>{
            if(x.FormDeliveryEvent_Typ=="Open")
            {
              if(fileInfoState?.msgChannel=="whatsapp"){
                let msgData:any={
                  To:'whatsapp:'+fileInfoState.fromNumber,
                  From:fileInfoState.number,
                  Bot_response:'Form is Opened',
                  Data:formInfoState?formInfoState:formInfoLocal,
                  domain :localStorage.getItem("ZoneNm")
                }
                sendMessageOnSave(msgData)
              }
              else if(fileInfoState?.msgChannel=="viber"){
                let msgData:any={
                  To:fileInfoState.fromNumber,
                  From:fileInfoState.number,
                  Bot_response:'Form is Opened',
                  Data:formInfoState?formInfoState:formInfoLocal,
                  channel:'viber_service',
                  domain :localStorage.getItem("ZoneNm")
                }
                sendMessageOnSave(msgData)
              }
             else  if(fileInfoState?.msgChannel=="line"){
                let msgData:any={
                  To:fileInfoState.fromNumber,
                  From:fileInfoState.number,
                  Bot_response:'Form is Opened',
                  Data:formInfoState?formInfoState:formInfoLocal,
                  channel:'line',
                  domain :localStorage.getItem("ZoneNm")
                }
                sendMessageOnSave(msgData)
              }
             else if(x.FormDelivery_Typ=="SMS"){
                let msgData:any={
                  To:fileInfoState.fromNumber,
                  From:fileInfoState.number,
                  Bot_response:'Form is Opened',
                  Data:formInfoState?formInfoState:formInfoLocal,
                  domain :localStorage.getItem("ZoneNm")
                }
                sendMessageOnSave(msgData)
              }
              else{
                notificationWithCustomUrl(x.FormDeliveryAction_Url,formInfoState?formInfoState:formInfoLocal,(res:any)=>{

                })
              }
            }
          })
            } catch (ex) {
              console.log(ex);
            }
          }
          //const doc=await PDFNet.PDFDoc.createFromBuffer(b)
          doc.initSecurityHandler();
          doc.lock();
          const approval_signature_field =
            await doc.createDigitalSignatureField("PDFTronApprovalSigGraph");
          const widgetAnnotApproval =
            await PDFNet.SignatureWidget.createWithDigitalSignatureField(
              doc,
              new PDFNet.Rect(300, 200, 200, 100),
              approval_signature_field
            );
          const pageCount = await doc.getPageCount();

          const page1 = await doc.getPage(pageCount);
          await page1.annotPushBack(widgetAnnotApproval);

          hasfield = true;
          const docbuf = await doc.saveMemoryBuffer(
            PDFNet.SDFDoc.SaveOptions.e_remove_unused
          );
         
          const blob = new Blob([docbuf], { type: "application/pdf" });
          instance.UI.loadDocument(blob);
        }
        // add your own license key as the second parameter, e.g. PDFNet.runWithCleanup(main, 'YOUR_LICENSE_KEY')
        
        if (!hasfield && state != "signature") 
        PDFNet.runWithCleanup(main);


        async function extractAnnotationSignature(annotation:any, docViewer:any) {
            ;
            // Create a new Canvas to draw the Annotation on
            const canvas = document.createElement("canvas");
            // Reference the annotation from the Document
            const pageMatrix = docViewer
              .getDocument()
              .getPageMatrix(annotation.PageNumber);
            // Set the height & width of the canvas to match the annotation
            canvas.height = annotation.Height;
            canvas.width = annotation.Width;
            const ctx:any = canvas.getContext("2d");
            // Translate the Annotation to the top Top Left Corner of the Canvas ie (0, 0)
            ctx.translate(-annotation.X, -annotation.Y);
            // Draw the Annotation onto the Canvas
            annotation.draw(ctx, pageMatrix);
            // Convert the Canvas to a Blob Object for Upload
            ;
            canvas.toBlob((b:any) => {
              b.arrayBuffer().then((buffer:any) => {
                te = buffer;
                setSignFile(buffer);
              });
            });
          
          }

          async function VerifyAllAndPrint() {
            const in_public_key_file_path='/entrust_class_3_intermediate.cer'
            const doc = await documentViewer.getDocument().getPDFDoc();
            doc.initSecurityHandler();
            doc.lock();
            console.log('==========');
            const opts = await PDFNet.VerificationOptions.create(PDFNet.VerificationOptions.SecurityLevel.e_compatibility_and_archiving);
      
            var fdf = await PDFNet.PDFDoc.createFromURL('/adobe_aatl_eutl.fdf');
          await  opts.loadTrustList(fdf); 
            // Add trust root to store of trusted certificates contained in VerificationOptions.
            // Use trust level corresponding to an identity trusted even for certification signatures.
            await opts.addTrustedCertificateFromURL(
              in_public_key_file_path,
              {},
              PDFNet.VerificationOptions.CertificateTrustFlag.e_default_trust + PDFNet.VerificationOptions.CertificateTrustFlag.e_certification_trust
            );
    
            // Iterate over the signatures and verify all of them.
            const digsig_fitr = await doc.getDigitalSignatureFieldIteratorBegin();
            let verification_status = true;
            for (; await digsig_fitr.hasNext(); await digsig_fitr.next()) {
              const curr = await digsig_fitr.current();
              const result = await curr.verify(opts);
              if (await result.getVerificationStatus()) {
                console.log('Signature verified, objnum: ' + (await (await curr.getSDFObj()).getObjNum()));
              } else {
                console.log('Signature verification failed, objnum: ' + (await (await curr.getSDFObj()).getObjNum()));
                verification_status = false;
              }
      
              switch (await result.getDigestAlgorithm()) {
                case PDFNet.DigestAlgorithm.Type.e_SHA1:
                  console.log('Digest algorithm: SHA-1');
                  break;
                case PDFNet.DigestAlgorithm.Type.e_SHA256:
                  console.log('Digest algorithm: SHA-256');
                  break;
                case PDFNet.DigestAlgorithm.Type.e_SHA384:
                  console.log('Digest algorithm: SHA-384');
                  break;
                case PDFNet.DigestAlgorithm.Type.e_SHA512:
                  console.log('Digest algorithm: SHA-512');
                  break;
                case PDFNet.DigestAlgorithm.Type.e_RIPEMD160:
                  console.log('Digest algorithm: RIPEMD-160');
                  break;
                case PDFNet.DigestAlgorithm.Type.e_unknown_digest_algorithm:
                  console.log('Digest algorithm: unknown');
                  break;
              }
      
              console.log(
                'Detailed verification result: \n\t' +
                  (await result.getDocumentStatusAsString()) +
                  '\n\t' +
                  (await result.getDigestStatusAsString()) +
                  '\n\t' +
                  (await result.getTrustStatusAsString()) +
                  '\n\t' +
                  (await result.getPermissionsStatusAsString())
              );
      
              const changes = await result.getDisallowedChanges();
              for (let i = 0; i < changes.length; ++i) {
                const change = changes[i];
                console.log('\tDisallowed change: ' + (await change.getTypeAsString()) + ', objnum: ' + (await change.getObjNum()));
              }
      
              // Get and print all the detailed trust-related results, if they are available.
              if (await result.hasTrustVerificationResult()) {
                const trust_verification_result = await result.getTrustVerificationResult();
                console.log((await trust_verification_result.wasSuccessful()) ? 'Trust verified.' : 'Trust not verifiable.');
                console.log(await trust_verification_result.getResultString());
      
                const tmp_time_t = await trust_verification_result.getTimeOfTrustVerification();
                switch (await trust_verification_result.getTimeOfTrustVerificationEnum()) {
                  case PDFNet.VerificationOptions.TimeMode.e_current:
                    console.log('Trust verification attempted with respect to current time (as epoch time):' + tmp_time_t);
                    break;
                  case PDFNet.VerificationOptions.TimeMode.e_signing:
                    console.log('Trust verification attempted with respect to signing time (as epoch time): ' + tmp_time_t);
                    break;
                  case PDFNet.VerificationOptions.TimeMode.e_timestamp:
                    console.log('Trust verification attempted with respect to secure embedded timestamp (as epoch time): ' + tmp_time_t);
                    break;
                }
      
                const cert_path = await trust_verification_result.getCertPath();
                if (cert_path.length === 0) {
                  console.log('Could not print certificate path.');
                } else {
                  console.log('Certificate path:');
                  for (let i = 0; i < cert_path.length; i++) {
                    console.log('\tCertificate:');
                    const full_cert = cert_path[i];
                    console.log('\t\tIssuer names:');
                    const issuer_dn = await (await full_cert.getIssuerField()).getAllAttributesAndValues();
                    for (let j = 0; j < issuer_dn.length; j++) {
                      console.log('\t\t\t' + (await issuer_dn[j].getStringValue()));
                    }
                    console.log('\t\tSubject names:');
                    const subject_dn = await (await full_cert.getSubjectField()).getAllAttributesAndValues();
                    for (let j = 0; j < subject_dn.length; j++) {
                      console.log('\t\t\t' + (await subject_dn[j].getStringValue()));
                    }
                    console.log('\t\tExtensions:');
                    const extension_dn = await full_cert.getExtensions();
                    for (let j = 0; j < extension_dn.length; j++) {
                      console.log('\t\t\t' + (await extension_dn[j].toString()));
                    }
                  }
                }
              } else {
                console.log('No detailed trust verification result available.');
              }
      
            
            }
      
            return verification_status;
          };
          async function save() {
            const doc = await documentViewer.getDocument().getPDFDoc();
           
            const approval_signature_field =
              await doc.createDigitalSignatureField("PDFTronApprovalSig");
            const widgetAnnotApproval =
              await PDFNet.SignatureWidget.createWithDigitalSignatureField(
                doc,
                new PDFNet.Rect(0, 0, 0, 0),
                approval_signature_field
              );
            const page1 = await doc.getPage(1);
            await page1.annotPushBack(widgetAnnotApproval);
            // const doc=await PDFNet.PDFDoc.createFromBuffer(arr);

            const found_approval_field = await doc.getField(
              "PDFTronApprovalSig"
            );
            
            const sigHandlerId = await doc.addStdSignatureHandlerFromURL(
              "/P360.pfx",
              "123456"
            );
            //  const sigHandlerId = await doc.addStdSignatureHandler('/pkcs7.p7b')
            const found_approval_signature_digsig_field =
              await PDFNet.DigitalSignatureField.createFromField(
                found_approval_field
              );
              await found_approval_signature_digsig_field.setDocumentPermissions(PDFNet.DigitalSignatureField.DocumentPermissions.e_no_changes_allowed);
          
           // found_approval_signature_digsig_field.setDocumentPermissions(PDFNet.DigitalSignatureField.DocumentPermissions.e_no_changes_allowed);
           console.log('Adding field permissions.');
      const fields_to_lock:Array<string>  = ['PDFTronApprovalSig'];
           await found_approval_signature_digsig_field.setFieldPermissions(PDFNet.DigitalSignatureField.FieldPermissions.e_lock_all);
           await found_approval_signature_digsig_field.signOnNextSaveWithCustomHandler(
              sigHandlerId
            );
           await found_approval_signature_digsig_field.setLocation(
              location
            );
           await found_approval_signature_digsig_field.setReason(
              reason? reason:"Document approval"
            );
           await found_approval_signature_digsig_field.setContactInfo(
              "www.p360.com"
            );
            
           
             // save to blob storage
             const buf = await doc.saveMemoryBuffer(
              PDFNet.SDFDoc.SaveOptions.e_remove_unused
            );

            state='signedFinal'
            instance.loadDocument(buf);

           
            const blob = new Blob([buf], { type: "application/pdf" });
            
            let srffile = new File([blob], "Signed_"+formRequestId+"_"+new Date().toISOString()+".pdf");
            
            console.log(typeof(buf))

            //SendformStatus
        
              
            
                
              const formData = new FormData();
                  formData.append('file',srffile);
                  formData.append('formId',formRequestId.toString());

                 saveToBlob(formData,(res:any)=>{
                  if(res){
                    //this is designed for out of office so To number will be Rep number and from number will be HCP/others
                    let tempdel:any=deliveryMode
                    if(deliveryModeLocal.length>0)
                        tempdel=  deliveryModeLocal        

                    tempdel.findIndex((x:any)=>{
                    if(x.FormDeliveryEvent_Typ=="Signature"|| x.FormDeliveryEvent_Typ=="Submit")
                    {
                      if(fileInfoState?.msgChannel=="whatsapp"){
                        let msgData:any={
                          To:'whatsapp:'+fileInfoState.fromNumber,
                          From:fileInfoState.number,
                          Bot_response:'Here is your signed form. '+res,
                          Url:res,
                          Data:formInfoState?formInfoState:formInfoLocal,
                          domain :localStorage.getItem("ZoneNm")
                        }
                        sendMessageOnSave(msgData)
                      }
                      else if(fileInfoState?.msgChannel=="viber"){
                        let msgData:any={
                          To:fileInfoState.fromNumber,
                          From:fileInfoState.number,
                          Bot_response:'Here is your signed form. '+res,
                          Url:res,
                          Data:formInfoState?formInfoState:formInfoLocal,
                          channel:'viber_service',
                          domain :localStorage.getItem("ZoneNm")
                        }
                        sendMessageOnSave(msgData)
                      }
                      else if(fileInfoState?.msgChannel=="line"){
                        let msgData:any={
                          To:fileInfoState.fromNumber,
                          From:fileInfoState.number,
                          Bot_response:'Here is your signed form. '+res,
                          Url:res,
                          Data:formInfoState?formInfoState:formInfoLocal,
                          channel:'line',
                          domain :localStorage.getItem("ZoneNm")
                        }
                        sendMessageOnSave(msgData)
                      }
                       else if(x.FormDelivery_Typ=="SMS"){
                          let msgData:any={
                            To:fileInfoState.fromNumber,
                            From:fileInfoState.number,
                            Bot_response:'Here is your signed form. '+res,
                            Url:res,
                            Data:formInfoState?formInfoState:formInfoLocal,
                            domain :localStorage.getItem("ZoneNm")
                          }
                    sendMessageOnSave(msgData)
                    }
                    else{
                      notificationWithCustomUrl(x.FormDeliveryAction_Url,formInfoState?formInfoState:formInfoLocal,(res:any)=>{
                  
                      })
                     }
                     }
                    })
                    formstatus({
                      formstatus: "completed",
                      SignedURL: res,
                      formRequestId: formRequestId
                  })
                    setTimeout(() => {
                      const url = window.URL.createObjectURL(blob);
                      const a = document.createElement("a");
                      a.style.display = "none";
                      a.href = url;
                      // the filename you want
                      a.download = "signed_doc.pdf";
                      document.body.appendChild(a);
                      a.click();
                      
                      let documentdoc:any=document
                      documentdoc.getElementById('save').style.display='none'
                    
                   }, 4000);
                    //sendMessageOnSave()
                  }
                 })

                       
          }
          async function addSignDetails(){
            console.log(signatureAnnotaionCustom1)
            const signCanvas = document.createElement('canvas');
		// Reference the annotation from the Document
		const pageMatrix = documentViewer.getDocument().getPageMatrix(signatureAnnotaionCustom1.PageNumber);
  
    signCanvas.height = signatureAnnotaionCustom1.Height;
		signCanvas.width = signatureAnnotaionCustom1.Width;
    const annotationList:any = [];
		const ctx:any = signCanvas.getContext('2d');
		// Translate the signatureAnnotaionCustom1 to the top Top Left Corner of the Canvas ie (0, 0)
		ctx.translate(-signatureAnnotaionCustom1.X, -signatureAnnotaionCustom1.Y);
    //signatureAnnotaionCustom1.Color = new Annotations.Color(1, 215, 88)
		signatureAnnotaionCustom1.setX(signatureAnnotaionCordinate.x);
		signatureAnnotaionCustom1.setY(signatureAnnotaionCordinate.y);
    
		//signatureAnnotaionCustom1.resize(new Math.rect(signatureAnnotaionCordinate.x, signatureAnnotaionCordinate.y, signatureAnnotaionCordinate.x + 40, signatureAnnotaionCordinate.y + 40))
		signatureAnnotaionCustom1.draw(ctx, pageMatrix);
    signCanvas.toBlob((blob: any) => {
      
			 createCustomAnnotation(blob, ["Signer Name:"+annotationManager.getCurrentUser(),'Signing Time:'+new Date().toLocaleString(),'Signer IP:'+ip,'Signing Reason:'+reason], annotationList, signatureAnnotaionCustom1.Width, signatureAnnotaionCustom1.Height)
       flatSign(annotationList)
      });
 async function createCustomAnnotation(signImg:any, data: string[],  annotationList:any, width:any, height:any) {
      let annotManager=annotationManager;
     
  
      class DigitalSignatureAnnotation extends Annotations.CustomAnnotation {
        constructor() {
          super('digitalSignature'); // provide the custom XFDF element name
          this.Subject = 'DigitalSignature';
        }
        draw(ctx:any, pageMatrix:any) {
          // the setStyles function is a function on markup annotations that sets up
          // certain properties for us on the canvas for the annotation's stroke thickness.
          this.setStyles(ctx, pageMatrix);
        
          const helper = new Annotations.CanvasHelper(ctx);
          const textParams = {
            fillColor: new Annotations.Color(255, 0, 0),
            opacity: 1,
            borderStyle: 'solid',
            fontSize: 4,
          }
          // first we need to translate to the annotation's x/y coordinates so that it's
          // drawn in the correct location
          ctx.translate(this.X, this.Y);
          const img = new Image();
          img.onload = (event) => {
            ctx.drawImage(event.target, 0, 0, 50, 50)
          }
  
          img.src = URL.createObjectURL(signImg);
          
          helper.drawText('Signed By', width+2, 0, textParams);
          let y = helper.measureText('Signed By')['actualBoundingBoxAscent'];
          
          let x=width+2
          data.forEach(info => {
            helper.drawText(info, x,y, textParams);
          //console.log(helper.measureText(info))
            let textHeight = helper.measureText(info)['actualBoundingBoxAscent'];
            y = y + textHeight;
          })
  
        }
      }
  
      DigitalSignatureAnnotation.prototype.elementName = 'digitalSignature';
      const customSignAnnotation = new DigitalSignatureAnnotation()
      console.log(signatureAnnotaionCordinate)
      customSignAnnotation.Width = 300;
      customSignAnnotation.Height = 200;
      customSignAnnotation.setPageNumber(signatureAnnotaionCordinate.pageNumber)
      customSignAnnotation.setX(signatureAnnotaionCordinate.x);
      customSignAnnotation.setY(signatureAnnotaionCordinate.y);
      customSignAnnotation.Color = new Annotations.Color(255, 0, 0);
  
      // annotManager.deleteAnnotations(annotManager.getAnnotationsList(), { force: false, isUndoRedo: true });
      annotationList.push(customSignAnnotation);
      annotManager.addAnnotations(annotationList);
      annotManager.drawAnnotationsFromList(annotationList);

      
      

    }
          } 
          document.getElementById('reasonSave')?.addEventListener('click',()=>{
            addSignDetails();
            
           
          })
          async function flatSign(annotationList:any){
    
            console.log('inside flatsign')
             state = "signature";
             const doc1 = documentViewer.getDocument()
            console.log(await annotationManager.getAnnotationsList())
            const xfdfString = await annotationManager.exportAnnotations({
              widgets: false,
            
             annotList:await annotationManager.getAnnotationsList()
            });

            const data = await doc1.getFileData({
              // saves the document with annotations in it
              xfdfString,
              flatten: true,
              
            });
            const arr = new Uint8Array(data);
            const blob = new Blob([arr], { type: "application/pdf" });
            instance.UI.loadDocument(blob);
            //;
          }
         
        documentViewer.addEventListener("documentLoaded", async () => {
          
          const doc = await documentViewer.getDocument().getPDFDoc();
          // dispatch(setDoc(doc))
          console.log(doc)
          if (state == "signature") {
            //document.getElementById("reason-popup").style.display = "block";
            save();
            state = "signed";
          }
          if(state=='signedFinal')
          VerifyAllAndPrint()
          annotationManager.addEventListener(
            "annotationSelected",
            async (annotationList:any) => {
              ;
              annotationList.forEach((annotation:any) => {
                if (annotation.Subject === "Signature"){
                  
                  
                  signatureAnnotaionCustom1=annotation;
                  signatureAnnotaionCordinate={
                    x:annotation.X,
                    y:annotation.Y,
                    pageNumber:annotation.PageNumber
                  }
                  extractAnnotationSignature(annotation, documentViewer);
                }
              });
            }
          );

          signatureTool.addEventListener('locationSelected', (pageCoordinates: any) => {
            console.log(pageCoordinates)
          });
          
          annotationManager.on("annotationChanged", async (e:any) => {
            // If annotation change is from import, return
            if (e.imported) {
              return;
            }
            e.forEach((annotation:any) => {
              if (annotation.Subject === "Signature")
              {
                
                signatureAnnotaionCustom1=annotation;
                  signatureAnnotaionCordinate={
                    x:annotation.X,
                    y:annotation.Y,
                    pageNumber:annotation.PageNumber
                  }
                  
                extractAnnotationSignature(annotation, documentViewer);
              }
            });
            const xfdfString =
              await annotationManager.exportAnnotationCommand();
            // Parse xfdfString to separate multiple annotation changes to individual annotation change
            const parser = new DOMParser();
            const commandData = parser.parseFromString(xfdfString, "text/xml");
            const addedAnnots = commandData.getElementsByTagName("add")[0];
            const modifiedAnnots =
              commandData.getElementsByTagName("modify")[0];
            const deletedAnnots = commandData.getElementsByTagName("delete")[0];

            // List of added annotations
            addedAnnots.childNodes.forEach((child) => {
              sendAnnotationChange(child, "add");
            });

            // // List of modified annotations
            modifiedAnnots.childNodes.forEach((child) => {
              sendAnnotationChange(child, "modify");
            });

            // // List of deleted annotations
            deletedAnnots.childNodes.forEach((child) => {
              sendAnnotationChange(child, "delete");
            });
          });
        });
      });
    }
  }
  }, [formRequestId]);
  useEffect(()=>{
    if(recepientName)
    {
      recepientNameLocal=recepientName;
      setRecepientNameState(recepientName);
    }
  },[recepientName])
  return (
    <div className="file-wrapper">
      <ReasonPopup show={showPopup} handleClose={(e:any)=>{
        console.log(e)
        setShowPopup(false);
        if(e){
        setReasondata(e);
        reason=e;
        document.getElementById('reasonSave')?.click()
        }
        }}/>
      <button style={{visibility:'hidden'}} id="reasonSave"></button>
      <div className="pdf-header">
        
        <span className='file-name'>Form</span>
        <button className='pdf-save-btn' id="save" data-testid='savebutton' onClick={()=>{setShowPopup(true)}}><SaveIcon /> Save</button>
      </div>
      <div
          className="webviewer"
          style={{ height: "100%" }}
          ref={viewer}
        ></div>
        
    </div>
  );
}

export default Sign;


